export default `
    -webkit-transform-origin: top;
    -webkit-transform: scale( .75 );
    margin-top: 0;
    padding-top: 40px;
    height: 75%;
`;
